import { render, staticRenderFns } from "./ContentVideo.vue?vue&type=template&id=2976a666&"
import script from "./ContentVideo.vue?vue&type=script&lang=js&"
export * from "./ContentVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports